import React from 'react';
import { t } from 'Src/i18n';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { Badge } from 'Components/frameworks/badge/Badge';
type AdditionalTransportFiltersHeaderProps = {
  state: TransportFiltersState;
  resetFilters: () => void;
};
export const AdditionalTransportFiltersHeader = ({
  state,
  resetFilters,
}: AdditionalTransportFiltersHeaderProps) => {
  const { totalFiltersSelected } = state;
  const { trackClickEvent } = useTrackEvent();
  return (
    <div
      data-testid="AdditionalTransportFiltersHeader"
      className="flex items-center justify-between"
    >
      <div className="flex items-center gap-10 text-20 font-semibold">
        {t('booking.common.layer.filtersTitle')}
        <Badge
          className="size-32 border-saffron bg-saffron text-14 text-black"
          label={`${totalFiltersSelected}`}
          variant="pill"
        />
      </div>
      <button
        type="button"
        onClick={() => {
          trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
            detail_click: 'filter_remove_all',
          });
          resetFilters();
        }}
        className="cursor-pointer text-16 font-semibold underline"
      >
        {t('filters.removeAll')}
      </button>
    </div>
  );
};
